module.exports = __webpack_public_path__ + "img/shoulder width.b0dec4de.png";